import i18n from "@/i18n";

export function translateTitle(title) {
  const { t, te } = i18n.global;
  if (te(`sengiI18n.${title}`)) return t(`sengiI18n.${title}`);
  return title;
}
